import React, { useEffect, useState, useContext, useCallback } from "react";
import { ErrorComponent, LoadingComponent, useExecutionDataView } from "@gooddata/sdk-ui";

import { Table, Typography } from "antd";
import { TfiWorld } from "react-icons/tfi";
import { ImFilePicture } from "react-icons/im";
import * as Md from "../../md/full";
import UserContext, { settingsAliases } from "../../contexts/User";
import MeasuresContext, { flagServiceM } from "../../contexts/Measures";
import { calculateAdjustment } from "../../utils/calculationUtils";
import moment from "moment";
import ImageViewer from "../ImageViewer";
import { RecordSwitchParameter } from "../../routes/Vehicles";
import Exportbtn from "../Export/Exportbtn";
import { utils, writeFileXLSX } from "xlsx";
import { useAppContext } from "../../contexts/AppContext";
import FiltersContext from "../../contexts/Filters";

export default function AdjustmentVehicles({ seriesBy, filters, selectedVehicle, footnote }) {
    const { kpiSettings, IncServices } = useContext(UserContext);
    const { selectedAdjDeposit } = useContext(MeasuresContext);
    const { getFilterValue } = useContext(FiltersContext);
    const { getCustlabelByCustId } = useAppContext();

    const { result, status } = useExecutionDataView({
        execution: {
            seriesBy: [...seriesBy, Md.Deposit.Avg, Md.OtrPrice.Avg, Md.Apr.Avg, Md.FinanceContrib.Avg, Md.TotalCharges.Avg, Md.TotalPayable.Avg, Md.FlMetallicPaint.Avg],
            slicesBy: [Md.CustId, Md.Version, Md.Channel3, Md.Url, Md.DateDatasets.DateOfScraping.Date.DdMmYyyy, Md.PictureURL, Md.PeriodCat],
            filters,
        },
    });

    const [data, setData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [selectedPicURL, setSelectedPicURL] = useState(undefined);
    const ctryid = getFilterValue("filterCountryId")[0];

    function cleanEmptyValues(dataSource, fieldNames = []) {
        let res = dataSource;
        fieldNames.forEach((fieldName) => {
            const motif = ["Interest Rate", "Screenshot", "Link"].includes(fieldName) ? dataSource.filter((elem) => [null, ""].includes(elem[fieldName])).length : dataSource.filter((elem) => Number(elem[fieldName]) === 0).length;
            if (motif === dataSource.length) {
                res = res.map((obj) => {
                    return Object.keys(obj)
                        .filter((key) => key !== fieldName)
                        .reduce((acc, nextKey) => {
                            return { ...acc, [nextKey]: obj[nextKey] };
                        }, {});
                });
            }
        });
        return res;
    }

    const downloadFile = useCallback(
        (data) => {
            data.forEach((obj) => {
                obj.Player = getCustlabelByCustId(obj.Player);
                delete obj.key;
                delete obj["Screenshot"];
            });
            const ws = utils.json_to_sheet(data);
            const wb = utils.book_new();
            utils.book_append_sheet(wb, ws, "Data");
            return new Promise((resolve, reject) => {
                resolve(writeFileXLSX(wb, `${selectedVehicle.replaceAll(" ", "_")}_Adjustment_table.xlsx`));
            });
        },
        [data, selectedVehicle],
    );

    useEffect(() => {
        const slices = result?.data().slices().toArray();
        if (slices && kpiSettings) {
            debugger;
            const dataSource = slices
                ?.map((slice) => {
                    const incServicesOnWeb = {
                        "Metallic Paint": ["UK", "GB"].includes(ctryid) ? Number(slice.dataPoints()[44].rawValue) : 0,
                        Maintenance: Number(slice.dataPoints()[5].rawValue),
                        Tyres: Number(slice.dataPoints()[7].rawValue),
                        Breakdown: Number(slice.dataPoints()[9].rawValue),
                        Replacement: Number(slice.dataPoints()[11].rawValue),
                        Insurance: Number(slice.dataPoints()[13].rawValue),
                        "Financial Loss": Number(slice.dataPoints()[15].rawValue),
                        "Winter Tyres": Number(slice.dataPoints()[17].rawValue),
                        [ctryid === "FR" ? "CertyNergy" : "EV Bonus"]: Number(slice.dataPoints()[19].rawValue),
                        "CO2 Malus": Number(slice.dataPoints()[21].rawValue),
                        ...(ctryid === "BE" && {
                            "Damage Insurance": slice.dataPoints()[35].rawValue !== null ? Number(slice.dataPoints()[35].rawValue) : 0,
                            "TPL Insurance": slice.dataPoints()[37].rawValue !== null ? Number(slice.dataPoints()[37].rawValue) : 0,
                        }),
                    };

                    return {
                        Player: slice.sliceTitles()[0],
                        Version: slice.sliceTitles()[1],
                        Link: slice.sliceTitles()[3].startsWith("http", 0) ? slice.sliceTitles()[3] : "",
                        Date: slice.sliceTitles()[4],
                        Period: slice.sliceTitles()[6],
                        Screenshot: slice.sliceTitles()[5],
                        List_Price: slice.dataPoints()[1].rawValue === "0" ? 0 : Number(slice.dataPoints()[1].rawValue) > 0 ? Math.round(Number(slice.dataPoints()[1].rawValue)) : null,
                        Finance_Type: slice.sliceTitles()[2],
                        Web_Rental: slice.dataPoints()[3].rawValue === "0" ? 0 : Number(slice.dataPoints()[3].rawValue) > 0 ? Math.round(Number(slice.dataPoints()[3].rawValue)) : null,
                        Web_Deposit: slice.dataPoints()[38].rawValue === "0" ? 0 : Math.round(Number(slice.dataPoints()[38].rawValue)),
                        Target_Deposit: selectedAdjDeposit === "Total Payable by month" ? "Total Payable" : Number(selectedAdjDeposit),
                        Adj_Deposit: slice.dataPoints()[2].rawValue === null ? null : Math.round(Number(slice.dataPoints()[2].rawValue)),
                        Adj_Rental: slice.dataPoints()[23].rawValue === "0" ? 0 : Number(slice.dataPoints()[23].rawValue) > 0 ? Math.round(Number(slice.dataPoints()[23].rawValue)) : null,
                        Leasing_Factor: slice.dataPoints()[24].rawValue === "0" ? 0 : Number(slice.dataPoints()[24].rawValue) > 0 ? Math.round(10000 * Number(slice.dataPoints()[24].rawValue)) / 100 : null,
                        Interest_Rate: slice.dataPoints()[40].rawValue === "0" ? 0 + "%" : Number(slice.dataPoints()[40].rawValue) > 0 ? Number(100 * Number(slice.dataPoints()[40].rawValue)).toFixed(2) + "%" : null,
                        RV: slice.dataPoints()[25].rawValue === "0" ? 0 : Number(slice.dataPoints()[25].rawValue) > 0 ? Math.round(Number(slice.dataPoints()[25].rawValue)) : null,
                        Discount: slice.dataPoints()[26].rawValue === "0" ? 0 : Number(slice.dataPoints()[26].rawValue) > 0 ? Math.round(Number(slice.dataPoints()[26].rawValue)) : null,
                        Finance_Contribution: slice.dataPoints()[41].rawValue === "0" ? 0 : Number(slice.dataPoints()[41].rawValue) > 0 ? Math.round(Number(slice.dataPoints()[41].rawValue)).toFixed(0) : null,
                        Total_Charges: slice.dataPoints()[42].rawValue === "0" ? 0 : Number(slice.dataPoints()[42].rawValue) > 0 ? Math.round(Number(slice.dataPoints()[42].rawValue)).toFixed(0) : null,
                        Total_Payable: slice.dataPoints()[43].rawValue === "0" ? 0 : Number(slice.dataPoints()[43].rawValue) > 0 ? Math.round(Number(slice.dataPoints()[43].rawValue)).toFixed(0) : null,
                        OTR_Price: slice.dataPoints()[39].rawValue === "0" ? 0 : Number(slice.dataPoints()[39].rawValue) > 0 ? Math.round(Number(slice.dataPoints()[39].rawValue)) : null,
                        // Dynamic services calculation
                        ...Object.entries(kpiSettings).reduce((acc, [flag, val]) => {
                            return {
                                ...acc,
                                [settingsAliases[flag][ctryid] || settingsAliases[flag]["default"]]: calculateAdjustment(slice, flagServiceM[flag].measureIndex, val, IncServices),
                            };
                        }, {}),
                        Web_Rental_Includes: Object.entries(incServicesOnWeb)
                            .filter((m) => m[1] === 1)
                            .map((m) => m[0])
                            .join(", "),
                    };
                })
                // Empty adj deposit
                .filter((elem) => (selectedAdjDeposit !== "Total Payable by month" ? elem["Adj_Deposit"] !== null : true));
            // Hide null or zero values
            const cleanedData = cleanEmptyValues(dataSource, columnsToBeCleaned);
            setData(cleanedData.map((m, i) => ({ key: i, ...m })));
            setColumns(
                Object.keys(cleanedData[0]).map((m) => ({
                    title: m,
                    fixed: ["Player", "Version"].includes(m) ? "left" : null,
                    dataIndex: m,
                    key: m,
                    width:
                        m === "Version"
                            ? 300
                            : m === "Link"
                            ? 90
                            : m === "Web_Rental_Includes"
                            ? dataSource
                                  .filter((elem) => elem["Web_Rental_Includes"].length > 0)
                                  .map((elem) => elem["Web_Rental_Includes"])
                                  .sort((a, b) => a.localeCompare(b))[0]?.length * 10 || 100
                            : 120,
                    align: m === "Version" ? "left" : "center",
                    render: (cell) => (
                        <div>
                            {m === "Player" ? (
                                <center>
                                    <img src={`/images/logos/Logo_${cell}.png`} width={70} height={70} alt={m} />
                                </center>
                            ) : m === "Link" ? (
                                cell ? (
                                    <center>
                                        <a href={cell} target="_blank" rel="noreferrer">
                                            <TfiWorld className="cursor-pointer w-4 h-4 text-indigo-500 hover:text-indigo-700" />
                                        </a>
                                    </center>
                                ) : null
                            ) : m === "Screenshot" ? (
                                cell ? (
                                    <center>
                                        <ImFilePicture className="cursor-pointer w-4 h-4 text-indigo-500 hover:text-indigo-700" onClick={() => setSelectedPicURL(cell)} />
                                    </center>
                                ) : null
                            ) : (
                                <Typography.Text style={{ fontSize: 11 }}>{cell}</Typography.Text>
                            )}
                        </div>
                    ),
                    sorter: ["Date", "List_Price", "Adj_Rental", "Player", "Version", "Finance_Type"].includes(m)
                        ? (a, b) => {
                              if (["List_Price", "Adj_Rental"].includes(m)) return a[m] - b[m];
                              else if (m === "Date") return moment(a.Date, "DD-MM-YYYY").diff(moment(b.Date, "DD-MM-YYYY"));
                              return a[m].localeCompare(b[m]);
                          }
                        : null,
                    // sortDirections: ['ascend', 'descend'],
                    showSorterTooltip: false,
                })),
            );
        }
    }, [result, kpiSettings, ctryid]);

    return (
        <>
            {status !== "error" && <RecordSwitchParameter className={(status === "loading" ? `opacity-40 select-none pointer-events-none` : "") + " ml-4 mb-6"} />}
            {status === "loading" && <LoadingComponent className="my-28" />}

            {status === "error" && <ErrorComponent message="Unable to calculate your query" description={"Please verify if the selected vehicles are compatible with the active filters"} />}

            {status === "success" && (
                <>
                    {data.length > 0 && (
                        <>
                            <div className="bg-white rounded-md overflow-hidden space-y-4">
                                <Table dataSource={data} columns={columns} rowKey="key" size="small" pagination={false} scroll={{ x: columns.reduce((a, b) => a + b.width, 0), y: 400 }} />
                                <p className="text-left text-xs font-medium">{footnote}</p>
                                <Exportbtn onclick={() => downloadFile(data)} />
                            </div>
                            {selectedPicURL && <ImageViewer url={selectedPicURL} selectPicHandler={setSelectedPicURL} />}
                        </>
                    )}
                </>
            )}
        </>
    );
}

const columnsToBeCleaned = [
    "Interest_Rate",
    "RV",
    "Discount",
    "Finance_Contribution",
    "Total_Charges",
    "Total_Payable",
    "Maintenance",
    "Breakdown",
    "Insurance",
    "Replacement",
    "Financial_Loss",
    "CO2_Malus",
    "Tyres",
    "Winter_Tyres",
    "EV_Bonus",
    "Damage Insurance",
    "TPL Insurance",
    "Link",
    "Screenshot",
];
